import { render, staticRenderFns } from "./lightness.vue?vue&type=template&id=1a0fa21e&"
import script from "./lightness.vue?vue&type=script&lang=js&"
export * from "./lightness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports